module.exports = __webpack_public_path__ + "img/antes_despues_158.4ab4ced3.png";